// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateOrder .customerWithLogo,
.CreateCustomer .customerWithLogo,
.EditOrder .customerWithLogo,
.ReadOrder .customerWithLogo,
.ReadCustomer .customerWithLogo,
.ReadEditCustomer .customerWithLogo,
.ReadEditOrder .customerWithLogo {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2em;
}
.CreateOrder .customerWithLogo .logo,
.CreateCustomer .customerWithLogo .logo,
.EditOrder .customerWithLogo .logo,
.ReadOrder .customerWithLogo .logo,
.ReadCustomer .customerWithLogo .logo,
.ReadEditCustomer .customerWithLogo .logo,
.ReadEditOrder .customerWithLogo .logo {
  margin-right: 15px;
  padding: 0 5%;
}
.CreateOrder .formContainer,
.CreateCustomer .formContainer,
.EditOrder .formContainer,
.ReadOrder .formContainer,
.ReadCustomer .formContainer,
.ReadEditCustomer .formContainer,
.ReadEditOrder .formContainer {
  margin-top: 3%;
}
.CreateOrder .formContainer .header,
.CreateCustomer .formContainer .header,
.EditOrder .formContainer .header,
.ReadOrder .formContainer .header,
.ReadCustomer .formContainer .header,
.ReadEditCustomer .formContainer .header,
.ReadEditOrder .formContainer .header {
  border-bottom: solid lightgray 1px;
  padding: 1.5em;
}
.CreateOrder .formContainer .sub-header,
.CreateCustomer .formContainer .sub-header,
.EditOrder .formContainer .sub-header,
.ReadOrder .formContainer .sub-header,
.ReadCustomer .formContainer .sub-header,
.ReadEditCustomer .formContainer .sub-header,
.ReadEditOrder .formContainer .sub-header {
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  margin-top: 24px;
}
.CreateOrder .formContainer .sub-header-slot,
.CreateCustomer .formContainer .sub-header-slot,
.EditOrder .formContainer .sub-header-slot,
.ReadOrder .formContainer .sub-header-slot,
.ReadCustomer .formContainer .sub-header-slot,
.ReadEditCustomer .formContainer .sub-header-slot,
.ReadEditOrder .formContainer .sub-header-slot {
  padding: 0;
  margin-top: 0;
  margin-bottom: 4px;
}
.CreateOrder .formContainer .subFormContainer,
.CreateCustomer .formContainer .subFormContainer,
.EditOrder .formContainer .subFormContainer,
.ReadOrder .formContainer .subFormContainer,
.ReadCustomer .formContainer .subFormContainer,
.ReadEditCustomer .formContainer .subFormContainer,
.ReadEditOrder .formContainer .subFormContainer {
  border: rgba(182, 182, 182, 0.5) 1px solid;
  border-radius: 10px;
  margin-bottom: 3%;
  padding: 0;
}
.CreateOrder .formContainer .content,
.CreateCustomer .formContainer .content,
.EditOrder .formContainer .content,
.ReadOrder .formContainer .content,
.ReadCustomer .formContainer .content,
.ReadEditCustomer .formContainer .content,
.ReadEditOrder .formContainer .content {
  padding: 24px 16px;
}
.CreateOrder .formContainer .content-files,
.CreateCustomer .formContainer .content-files,
.EditOrder .formContainer .content-files,
.ReadOrder .formContainer .content-files,
.ReadCustomer .formContainer .content-files,
.ReadEditCustomer .formContainer .content-files,
.ReadEditOrder .formContainer .content-files {
  padding-top: 8px;
}
.CreateOrder .formContainer .MuiInputBase-root,
.CreateOrder .formContainer .infoRow,
.CreateCustomer .formContainer .MuiInputBase-root,
.CreateCustomer .formContainer .infoRow,
.EditOrder .formContainer .MuiInputBase-root,
.EditOrder .formContainer .infoRow,
.ReadOrder .formContainer .MuiInputBase-root,
.ReadOrder .formContainer .infoRow,
.ReadCustomer .formContainer .MuiInputBase-root,
.ReadCustomer .formContainer .infoRow,
.ReadEditCustomer .formContainer .MuiInputBase-root,
.ReadEditCustomer .formContainer .infoRow,
.ReadEditOrder .formContainer .MuiInputBase-root,
.ReadEditOrder .formContainer .infoRow {
  margin-bottom: 1.5em;
}
.CreateOrder .subFormContainer,
.CreateCustomer .subFormContainer,
.EditOrder .subFormContainer,
.ReadOrder .subFormContainer,
.ReadCustomer .subFormContainer,
.ReadEditCustomer .subFormContainer,
.ReadEditOrder .subFormContainer {
  border: rgba(182, 182, 182, 0.5) 1px solid;
}
.CreateOrder .successMsg,
.CreateCustomer .successMsg,
.EditOrder .successMsg,
.ReadOrder .successMsg,
.ReadCustomer .successMsg,
.ReadEditCustomer .successMsg,
.ReadEditOrder .successMsg {
  margin: 5% auto;
}
.CreateOrder .ant-card-body > .ant-row:last-child,
.CreateCustomer .ant-card-body > .ant-row:last-child,
.EditOrder .ant-card-body > .ant-row:last-child,
.ReadOrder .ant-card-body > .ant-row:last-child,
.ReadCustomer .ant-card-body > .ant-row:last-child,
.ReadEditCustomer .ant-card-body > .ant-row:last-child,
.ReadEditOrder .ant-card-body > .ant-row:last-child {
  display: none;
}
.CreateOrder .ant-divider-horizontal,
.CreateCustomer .ant-divider-horizontal,
.EditOrder .ant-divider-horizontal,
.ReadOrder .ant-divider-horizontal,
.ReadCustomer .ant-divider-horizontal,
.ReadEditCustomer .ant-divider-horizontal,
.ReadEditOrder .ant-divider-horizontal {
  display: none !important;
}
.CreateOrder .thumbnailContainer,
.CreateCustomer .thumbnailContainer,
.EditOrder .thumbnailContainer,
.ReadOrder .thumbnailContainer,
.ReadCustomer .thumbnailContainer,
.ReadEditCustomer .thumbnailContainer,
.ReadEditOrder .thumbnailContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2%;
  padding: 5%;
}
.CreateOrder .newEmail,
.CreateCustomer .newEmail,
.EditOrder .newEmail,
.ReadOrder .newEmail,
.ReadCustomer .newEmail,
.ReadEditCustomer .newEmail,
.ReadEditOrder .newEmail {
  margin-top: 4%;
}
.CreateOrder .newContactCont,
.CreateCustomer .newContactCont,
.EditOrder .newContactCont,
.ReadOrder .newContactCont,
.ReadCustomer .newContactCont,
.ReadEditCustomer .newContactCont,
.ReadEditOrder .newContactCont {
  width: 100%;
}
.CreateOrder .CreateContactRow,
.CreateCustomer .CreateContactRow,
.EditOrder .CreateContactRow,
.ReadOrder .CreateContactRow,
.ReadCustomer .CreateContactRow,
.ReadEditCustomer .CreateContactRow,
.ReadEditOrder .CreateContactRow {
  display: grid;
  grid-template-columns: 3fr 1fr;
  place-items: center;
  justify-content: center;
}
.CreateOrder .CreateContactRow .textField *,
.CreateCustomer .CreateContactRow .textField *,
.EditOrder .CreateContactRow .textField *,
.ReadOrder .CreateContactRow .textField *,
.ReadCustomer .CreateContactRow .textField *,
.ReadEditCustomer .CreateContactRow .textField *,
.ReadEditOrder .CreateContactRow .textField * {
  margin-bottom: 0;
}
.CreateOrder .decide .iconsCont,
.CreateCustomer .decide .iconsCont,
.EditOrder .decide .iconsCont,
.ReadOrder .decide .iconsCont,
.ReadCustomer .decide .iconsCont,
.ReadEditCustomer .decide .iconsCont,
.ReadEditOrder .decide .iconsCont {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.CreateOrder .decide .iconsCont .icon,
.CreateCustomer .decide .iconsCont .icon,
.EditOrder .decide .iconsCont .icon,
.ReadOrder .decide .iconsCont .icon,
.ReadCustomer .decide .iconsCont .icon,
.ReadEditCustomer .decide .iconsCont .icon,
.ReadEditOrder .decide .iconsCont .icon {
  cursor: pointer;
}
.CreateOrder .campaignRow,
.CreateCustomer .campaignRow,
.EditOrder .campaignRow,
.ReadOrder .campaignRow,
.ReadCustomer .campaignRow,
.ReadEditCustomer .campaignRow,
.ReadEditOrder .campaignRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.CreateOrder .campaignRow .icon,
.CreateCustomer .campaignRow .icon,
.EditOrder .campaignRow .icon,
.ReadOrder .campaignRow .icon,
.ReadCustomer .campaignRow .icon,
.ReadEditCustomer .campaignRow .icon,
.ReadEditOrder .campaignRow .icon {
  margin-bottom: 17px;
}`, "",{"version":3,"sources":["webpack://./src/views/Orders/CreateOrder/style.scss"],"names":[],"mappings":"AAWE;;;;;;;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AAJJ;AAKI;;;;;;;EACE,kBAAA;EACA,aAAA;AAGN;AAAE;;;;;;;EACE,cAAA;AAQJ;AAPI;;;;;;;EACE,kCAAA;EACA,cAAA;AAeN;AAbI;;;;;;;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;AAqBN;AAnBI;;;;;;;EACE,UAAA;EACA,aAAA;EACA,kBAAA;AA2BN;AAzBI;;;;;;;EACE,0CAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;AAiCN;AA/BI;;;;;;;EACE,kBAAA;AAuCN;AApCI;;;;;;;EACE,gBAAA;AA4CN;AAzCI;;;;;;;;;;;;;;EAEE,oBAAA;AAuDN;AAnDE;;;;;;;EACE,0CAAA;AA2DJ;AAxDE;;;;;;;EACE,eAAA;AAgEJ;AA5DE;;;;;;;EACE,aAAA;AAoEJ;AAlEE;;;;;;;EACE,wBAAA;AA0EJ;AAvEE;;;;;;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;AA+EJ;AA7EE;;;;;;;EACE,cAAA;AAqFJ;AAnFE;;;;;;;EACE,WAAA;AA2FJ;AAzFE;;;;;;;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,uBAAA;AAiGJ;AA/FI;;;;;;;EACE,gBAAA;AAuGN;AAnGI;;;;;;;EACE,aAAA;EACA,kCAAA;AA2GN;AA1GM;;;;;;;EACE,eAAA;AAkHR;AA7GE;;;;;;;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAqHJ;AApHI;;;;;;;EACE,mBAAA;AA4HN","sourcesContent":[".CreateOrder,\n.CreateCustomer,\n.EditOrder,\n.ReadOrder,\n.ReadCustomer,\n.ReadEditCustomer,\n.ReadEditOrder {\n  $borderColor: rgba(\n    $color: #b6b6b625,\n    $alpha: 0.5,\n  );\n  .customerWithLogo {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    gap: 2em;\n    .logo {\n      margin-right: 15px;\n      padding: 0 5%;\n    }\n  }\n  .formContainer {\n    margin-top: 3%;\n    .header {\n      border-bottom: solid lightgray 1px;\n      padding: 1.5em;\n    }\n    .sub-header {\n      display: flex;\n      justify-content: space-between;\n      padding: 0 16px;\n      margin-top: 24px;\n    }\n    .sub-header-slot {\n      padding: 0;\n      margin-top: 0;\n      margin-bottom: 4px;\n    }\n    .subFormContainer {\n      border: $borderColor 1px solid;\n      border-radius: 10px;\n      margin-bottom: 3%;\n      padding: 0;\n    }\n    .content {\n      padding: 24px 16px;\n    }\n\n    .content-files {\n      padding-top: 8px;\n    }\n\n    .MuiInputBase-root,\n    .infoRow {\n      margin-bottom: 1.5em;\n    }\n  }\n\n  .subFormContainer {\n    border: $borderColor 1px solid;\n  }\n\n  .successMsg {\n    margin: 5% auto;\n  }\n\n  // preview images multi component\n  .ant-card-body > .ant-row:last-child {\n    display: none;\n  }\n  .ant-divider-horizontal {\n    display: none !important;\n  }\n\n  .thumbnailContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 2%;\n    padding: 5%;\n  }\n  .newEmail {\n    margin-top: 4%;\n  }\n  .newContactCont {\n    width: 100%;\n  }\n  .CreateContactRow {\n    display: grid;\n    grid-template-columns: 3fr 1fr;\n    place-items: center;\n    justify-content: center;\n\n    .textField * {\n      margin-bottom: 0;\n    }\n  }\n  .decide {\n    .iconsCont {\n      display: grid;\n      grid-template-columns: 1fr 1fr 1fr;\n      .icon {\n        cursor: pointer;\n      }\n    }\n  }\n\n  .campaignRow {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    .icon {\n      margin-bottom: 17px;\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
